<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data.item).length === 0
            ? $t('NavMenuItem.SystemSection.RolesPage.AddNew')
            : $t('NavMenuItem.SystemSection.RolesPage.Update')
        }}
        {{ $t('NavMenuItem.SystemSection.RolesPage.Item') }}
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :key="$vs.rtl">
      <div class="p-6">
        <!-- ROLE -->
        <vs-select
          v-model="role"
          :label="$t('NavMenuItem.SystemSection.RolesPage.Role')"
          class="mt-5 w-full"
          name="role-name"
          v-validate="'required'"
        >
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in zipSelectItems(data.roles)"
          />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('role-name')">{{
          errors.first('role-name')
        }}</span>

        <!-- ACTIVITY -->
        <vs-select
          v-model="activity"
          :label="$t('NavMenuItem.SystemSection.RolesPage.Activity')"
          class="mt-5 w-full"
          name="activity-name"
          v-validate="'required'"
        >
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in zipSelectItems(data.actions)"
          />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('activity-name')">{{
          errors.first('activity-name')
        }}</span>

        <!-- RESOURCE -->
        <vs-select
          v-model="resource"
          :label="$t('NavMenuItem.SystemSection.RolesPage.Resource')"
          class="mt-5 w-full"
          name="resource-name"
          v-validate="'required'"
        >
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in zipSelectItems(data.resources)"
          />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('resource-name')">{{
          errors.first('resource-name')
        }}</span>

        <!-- ATTRIBUTES -->
        <vs-input
          icon-pack="feather"
          icon="icon-shield"
          :label="$t('NavMenuItem.SystemSection.RolesPage.Attributes')"
          v-model="attributes"
          class="mt-5 w-full"
          v-validate="{ required: true }"
          name="attributes-name"
        />
        <span class="text-danger text-sm" v-show="errors.has('attributes-name')">{{
          errors.first('attributes-name')
        }}</span>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{
        $t('NavMenuItem.SystemSection.RolesPage.Submit')
      }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{
        $t('NavMenuItem.SystemSection.RolesPage.Cancel')
      }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dataId: null,
      role: null,
      activity: null,
      resource: null,
      attributes: '*, !owner'
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data.item).length === 0) {
        this.$validator.reset()
      }
      this.initValues()
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.role && this.activity && this.resource && this.attributes !== ''
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    notifyError(error, subject) {
      this.$vs.notify({
        title: subject,
        text: error.message,
        color: 'danger',
        position: 'bottom-center'
      })
    },
    notifySuccess(message, subject) {
      this.$vs.notify({
        title: subject,
        text: message,
        color: 'success',
        position: 'bottom-center'
      })
    },
    zipSelectItems(arr) {
      const jsUcfirst = string => string.charAt(0).toUpperCase() + string.slice(1)
      return arr.map((v, i) => Object.assign({}, { text: jsUcfirst(v), value: arr[i] }))
    },
    initValues() {
      if (this.data.item.id) {
        this.dataId = this.data.item.id
        this.role = this.data.item.role
        this.activity = this.data.item.action
        this.resource = this.data.item.resource
        this.attributes = this.data.item.attributes.join(', ')
      } else {
        this.role = null
        this.activity = null
        this.resource = null
        this.attributes = '*, !owner'
      }
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            role: this.role,
            action: this.activity,
            resource: this.resource,
            attributes: this.attributes.split(',').map(attr => attr.trim())
          }

          if (this.dataId !== null) {
            this.$http
              .put(`grants/${this.dataId}`, obj)
              .then(response => {
                this.$notifySuccess(
                  `With this ${response.data.role}, ${response.data.resource}, ${response.data.action}`,
                  'Object Created'
                )
              })
              .catch(error => this.$notifyError(error, 'An Error Occurred'))
          } else {
            this.$http
              .post('grants', obj)
              .then(response => {
                this.$notifySuccess(
                  `With this ${response.data.role}, ${response.data.resource}, ${response.data.action}`,
                  'Object Created'
                )
              })
              .catch(error => this.$notifyError(error, 'An Error Occurred'))
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
